// 针对表格行的处理函数
import Sortable from 'sortablejs'
/**
 * 处理在表格中添加新行的函数
 * @param {Array} data - 当前表格的数据数组
 * @param {Object} format - 新行的格式对象
 * @param {number} index - 要插入新行的位置索引
 * @returns {Array} - 包含新行的更新后的数据数组
 */
export function handleAddRow (data, format, index) {
  // 通过深拷贝创建一个新行对象，避免引用问题
  const newRow = { ...format, index: data.length }

  // 返回更新后的数据数组
  // data.forEach((item, index) => {
  //   item.index = index + 1
  // })
  // 插入新行到指定索引位置
  data.splice(index + 1, 0, newRow)

  console.log('handleAddRow:', data)
  return data
}
/**
 * 处理复制行的函数
 *
 * @param {Array} data - 原始数据数组
 * @param {Object} format - 新行的格式模板
 * @param {number} index - 插入新行的位置索引
 * @returns {Array} 返回更新后的数据数组
 */
export function handleCopyRow (data, format, index) {
  // 深拷贝整个数据数组（确保响应式系统能检测到变化）
  const newData = JSON.parse(JSON.stringify(data))

  // 创建新行（使用格式模板）
  const newRow = {
    ...format,
    index: newData.length + 1
  }
  // 在原数据中插入新行
  data.splice(index + 1, 0, newRow)

  console.log('handleCopyRow:', data)
  return data
}
/**
 * 处理在表格中删除指定行的函数
 * @param {Array} data - 当前表格的数据数组
 * @param {number} index - 要删除的行的位置索引
 * @returns {Array} - 不包含指定行的更新后的数据数组
 */
export function handleDeleteRow (data, index) {
  // 从指定索引位置删除一行
  data.splice(index, 1)
  // data.__v_raw.forEach((item) => {
  //   item.index = data.indexOf(item) + 1
  // })
  console.log('handleDeleteRow:', data)
  // 返回更新后的数据数组
  return data
}

/**
 * 处理表格行的拖动排序功能
 *
 * @param data 需要排序的数据数组
 * @param onSortComplete 排序完成后调用的回调函数，接收排序后的数据作为参数
 */
export function handleDragRow (data, onSortComplete) {
  console.log('排序前的数据', data)
  const tbody = document.querySelector('.el-table__body-wrapper tbody')
  if (!tbody) {
    console.error('Draggable element not found:', '.el-table__body-wrapper tbody')
    return
  }

  Sortable.create(tbody, {
    animation: 350, // 增加动画时间使效果更平滑
    easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)', // 添加缓动函数实现更自然的动画
    handle: '.drag_handle', // 指定拖动句柄

    onStart: (evt) => {
      // 添加缩放效果
      evt.item.style.transform = 'scale(1.02)'
      evt.item.style.boxShadow = '0 10px 20px rgba(0,0,0,0.1)'
      evt.item.style.zIndex = '1000'
    },

    onEnd: (evt) => {
      // 恢复原始样式
      evt.item.style.transform = ''
      evt.item.style.boxShadow = ''
      evt.item.style.zIndex = ''

      const currentRow = data.splice(evt.oldIndex, 1)[0]
      data.splice(evt.newIndex, 0, currentRow)
      const sortedData = JSON.parse(JSON.stringify(data))

      if (typeof onSortComplete === 'function') {
        onSortComplete(sortedData)
      }
    }
  })
}
/**
 * 检查数据数组中指定键的值是否存在重复
 * @param {Array} data - 要检查的数据数组，数组中的每个元素是一个对象
 * @param {string} key - 要检查重复值的键名
 * @returns {Array} - 返回重复值的数量组成的数组，如果没有重复值则返回空数组
 */
export function hasDuplicateData (data, key) {
  // 用于存储每个值出现的次数
  const valueCount = {}
  // 遍历数据数组，统计每个值出现的次数
  data.forEach(row => {
    // 如果 valueCount 中已经有该值的计数，则加 1；否则初始化为 1
    if (row[key] !== '') {
      valueCount[row[key]] = (valueCount[row[key]] || 0) + 1
    }
  })
  // 过滤出出现次数大于 1 的值的数量
  return Object.keys(valueCount).filter(count => valueCount[count] > 1)
}
/**
* 检查数据中是否存在两个字段组合重复的情况
*
* @param {Array} data - 数据数组，每个元素是一个对象
* @param {string} key1 - 第一个字段的键名
* @param {string} key2 - 第二个字段的键名
* @returns {Array} - 出现重复的字段组合值数组，若无重复则返回空数组
*/
export function hasDuplicateCombined(data, key1, key2) {
  const combinedCount = {}; // 存储拼接值的出现次数
  data.forEach(row => {
    // 拼接两个字段（用分隔符避免歧义，如"0001"+"01"和"000"+"101"不分隔会冲突）
    const combinedValue = `${row[key1] || ''}-${row[key2] || ''}`;
    if (combinedValue) { // 跳过空值拼接的情况
      combinedCount[combinedValue] = (combinedCount[combinedValue] || 0) + 1;
    }
  });
  // 过滤出出现次数 > 1 的拼接值
  return Object.keys(combinedCount).filter(value => combinedCount[value] > 1);
}

/**
 * 为包含重复数据的表格行应用样式
 * @param {Object} row - 当前表格行的数据对象
 * @param {Array} duplicateDate - 包含重复值的数组
 * @param {string} key - 用于检查重复值的键名
 * @returns {string} - 如果行包含重复值，则返回 'warning-row'；否则返回空字符串
 */
export function styleDuplicateRow (row, duplicateDate, key) {
  // 检查当前行中指定键的值是否存在于重复值数组中
  if (duplicateDate.includes(row[key].toString())) {
    // 如果存在重复值，则返回 'warning-row' 样式类名
    return 'warning-row'
  } else {
    // 如果不存在重复值，则返回空字符串
    return ''
  }
}
